// extracted by mini-css-extract-plugin
export var inputHolder = "JobsSearch-module--input-holder--2606w";
export var inputSearch = "JobsSearch-module--input-search--UH-9b";